import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { Alert, DataTable, Empty, Muted, PageHeader, Section } from '@/components/ui'
import { fetchKnowledge } from './api'

export function KnowledgeBasePage() {
  const kb = useQuery({ queryKey: ['wi', 'knowledge'], queryFn: fetchKnowledge })
  const rows = kb.data || []

  return (
    <section className="hi-page">
      <PageHeader
        title="Base de conhecimento"
        subtitle="Snapshots vigentes via Flow Intelligence. Editor rico permanece no legado."
        actions={
          <a className="btn btn-secondary" href={legacyAppUrl('#/knowledge-base')}>
            Legado
          </a>
        }
      />
      <Section title="Snapshots" flush>
        {kb.isLoading ? <Muted>Carregando…</Muted> : null}
        {kb.isError ? (
          <Alert tone="danger">
            {kb.error instanceof ApiError ? kb.error.message : 'Falha ao listar knowledge.'}
          </Alert>
        ) : null}
        {!kb.isLoading && rows.length === 0 ? <Empty>Nenhum snapshot vigente.</Empty> : null}
        {rows.length > 0 ? (
          <DataTable>
            <thead>
              <tr>
                <th>Título / tipo</th>
                <th>Cargo</th>
                <th>Departamento</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={String(r.id || i)}>
                  <td>
                    <strong>{String(r.titulo || r.nome || r.tipo || 'Snapshot')}</strong>
                    {r.tipo ? <div className="hi-muted">{String(r.tipo)}</div> : null}
                  </td>
                  <td>{String(r.cargo_nome || r.cargo || '—')}</td>
                  <td>{String(r.departamento_nome || r.departamento || '—')}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        ) : null}
      </Section>
    </section>
  )
}
